import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axiosInstance from '../utils/axiosInstance'
import { toast } from 'react-toastify';

const initialState = {
  loading: false,
  platforms: [],
  platformList: [],
  count: 0,
  dashboardStatics: [],
  error: {},
}

export const fetchPlatforms = createAsyncThunk('platformSlice/fetchPlatforms', async (data, thunkAPI) => {
  try {
    let url = `/platforms`
    if (data.queryString) {
      url += data.queryString

    }

    if (data?.minimal) {
      url += `?minimal=true`
    }
    if (data?.industry_id)
      url += `&industry_id=${data.industry_id}`

    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch roles');
  }
});
export const fetchPlatformsList = createAsyncThunk('platformSlice/fetchPlatformsList', async (data, thunkAPI) => {
  try {
    
    let url = `/platforms?page=1&page_size=100&minimal=true ${data?.queryString ?data.queryString:""} `
    if (data?.industry_id){
      url += `&industry_id=${data.industry_id}`
    }


    const response = await axiosInstance.get(url);
    
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch roles');
  }
});

export const deletePlatform = createAsyncThunk('platformSlice/deletePlatform', async (id, thunkAPI) => {
  console.log("userId", id);
  try {
    const response = await axiosInstance.delete(`/platforms/${id}`);
    console.log("response in del", response);
    response.data = id
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete role');
  }
});

export const deletePlatformSetting = createAsyncThunk('platformSlice/deletePlatformSetting', async (values, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/platforms/${values.id}/settings/${values.settingId}`);
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete role');
  }
});

export const fetchPlatformById = createAsyncThunk('platformSlice/fetchPlatformById', async (uuid, thunkAPI) => {
  console.log("userId", uuid);
  try {
    const response = await axiosInstance.delete(`/platforms/${uuid}`);
    console.log("response in del", response);
    response.data = uuid
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete role');
  }
});

export const createPlatform = createAsyncThunk('platformSlice/createPlatform', async (values, thunkAPI) => {
  try {
    const response = await axiosInstance.post('/platforms', values);
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete role');
  }
});

export const updatePlatform = createAsyncThunk('platformSlice/updatePlatform', async (values, thunkAPI) => {
  console.log("values on updaye", values);
  try {
    const response = await axiosInstance.patch(`/platforms/${values?.id}`, values);
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete role');
  }
});

export const toggleActivation = createAsyncThunk('platformSlice/toggleActivation', async (id, thunkAPI) => {
  console.log("toggleActivation", id);
  try {
    const response = await axiosInstance.post(`/platforms/${id}/toggle-activation`);
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete role');
  }
});

export const getDashboardData = createAsyncThunk('platformSlice/getDashboardData', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/statistics?start_date=${payload?.startDate}&end_date=${payload?.endDate}`);
    return response
  } catch (error) {
    console.log("dashboard data get error", error);

    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete role');
  }
});

export const platformSlice = createSlice({
  name: 'platformSlice',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    // fetch platforms
    builder.addCase(getDashboardData.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getDashboardData.fulfilled, (state, action) => {
      state.dashboardStatics = action.payload?.data?.data;
      state.loading = false;
    });
    builder.addCase(getDashboardData.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    // fetch platforms
    builder.addCase(fetchPlatforms.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchPlatforms.fulfilled, (state, action) => {
      state.platforms = action?.payload?.data?.results;
      state.count = action?.payload?.data?.count;
      state.loading = false;
    });
    builder.addCase(fetchPlatforms.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    // fetch platforms
    builder.addCase(fetchPlatformsList.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchPlatformsList.fulfilled, (state, action) => {
      state.platformList = action.payload.data.results;
      state.loading = false;
    });
    builder.addCase(fetchPlatformsList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    //create platforms
    builder.addCase(createPlatform.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(createPlatform.fulfilled, (state, action) => {
      state.loading = false;
      state.platforms = [action?.payload?.data.data, ...state.platforms];
      if (action?.payload?.status == 201) {
        toast.success("Platform created successfully")
      }
    });
    builder.addCase(createPlatform.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    //update platforms
    builder.addCase(updatePlatform.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(updatePlatform.fulfilled, (state, action) => {

      const updatedPlatform = action.payload?.data?.data;
      if (action.payload.status == 200) {
        state.platforms = state.platforms.map(platform =>
          platform.id === updatedPlatform.id ? updatedPlatform : platform
        );
        toast.success("Platform updated Successfully !")
      }
      state.loading = false;
    });
    builder.addCase(updatePlatform.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    //delete platforms
    builder.addCase(deletePlatform.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deletePlatform.fulfilled, (state, action) => {
      state.loading = false;
      state.platforms = state.platforms.filter((ele) => ele.uuid !== action?.payload?.data);
      if (action?.payload?.status == 204) {
        toast.success("Platform deleted successfully")
      }
    });
    builder.addCase(deletePlatform.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    // delete platform setting
    builder.addCase(deletePlatformSetting.pending, (state) => {
      // state.loading = true;
      state.error = null;
    });
    builder.addCase(deletePlatformSetting.fulfilled, (state, action) => {
      // state.loading = false;
      state.error = null;
    });
    builder.addCase(deletePlatformSetting.rejected, (state, action) => {
      // state.loading = false;
      state.error = action.payload;
    });
    // delete platform setting
    builder.addCase(toggleActivation.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(toggleActivation.fulfilled, (state, action) => {
      const id = action?.payload?.data?.data?.id;
      state.platforms = state.platforms.map(platform =>
        platform.id === id ? action?.payload?.data?.data : platform
      );
      state.loading = false;
      state.error = null;
      if (action?.payload?.status == 200) {
        toast.success("Platform updated successfully")
      }
    });
    builder.addCase(toggleActivation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
})


export default platformSlice.reducer